import React, { memo } from 'react';
import { CbmModal as Modal } from '@groupelacentrale/contact-storybook';
import { useModalState } from 'hooks';
import './PublicationOption.scss';

interface Props {
  strengths: Array<{ label: string; iconUrl: string }>;
}

const StrengthsModal: React.FC<Props> = memo(({ strengths }) => {
  const { isOpen, open, close } = useModalState();

  return (
    <>
      <span className="strengths-handle" onClick={open}>
        Voir les points forts de mon annonce
      </span>
      <Modal title="Points forts de mon annonce" isOpen={isOpen} onClose={close} showCloseButton size="medium">
        <ul className="strengths-list">
          {strengths.map(strength => (
            <li key={strength.label}>
              <img src={strength.iconUrl} alt={strength.label} />
              <div>{strength.label}</div>
            </li>
          ))}
        </ul>
      </Modal>
    </>
  );
});

StrengthsModal.displayName = 'StrengthsModal';

export { StrengthsModal };
